import { STRING } from "@constants";
import { CustomerRead } from "@types";
import { formatDate } from "@utils";

const T = STRING.CUSTOMER_DETAILS;

export function getCustomerDetails(data?: CustomerRead | null) {
  if (!data) return { sections: [] };

  const sections: any[] = [];

  sections.push(
    {
      title: T.PERSONAL_INFO,
      icon: "pi-user",
      fields: [
        { label: T.FIRST_NAME, value: data.firstName },
        { label: T.MIDDLE_NAME, value: data.middleName },
        { label: T.LAST_NAME, value: data.lastName },
        { label: T.BUSINESS_NAME, value: data.businessName },
        {
          label: T.BIRTHDAY,
          value: formatDate(data.birthday),
          icon: "pi-calendar",
        },
        { label: T.ENTITY_NUMBER, value: data.entityNumber },
      ],
    },
    {
      title: T.CONTACT_INFO,
      icon: "pi-phone",
      fields: [
        { label: T.EMAIL, value: data.email, icon: "pi-envelope" },
        { label: T.PHONE, value: data.phoneNumber },
        { label: T.PHONE_TYPE, value: data.phoneType },
        { label: T.WEB_PAGE, value: data.webPage, icon: "pi-globe" },
        {
          label: T.CAN_TEXT,
          value: data.canText ? T.YES : T.NO,
          icon: "pi-comment",
        },
      ],
    },
    {
      title: T.LICENSE_INFO,
      icon: "pi-id-card",
      fields: [
        { label: T.LICENSE, value: data.driversLicense },
        { label: T.DL_STATE, value: data.driversLicenseState },
        {
          label: T.DL_EXPIRATION,
          value: formatDate(data.driversLicenseExpiration),
          icon: "pi-calendar",
        },
        { label: T.IS_MILITARY, value: data.isMilitary ? T.YES : T.NO },
        { label: T.MILITARY_BRANCH, value: data.branchOfMilitary },
        { label: T.MILITARY_STATUS, value: data.militaryStatus },
        { label: T.ETS_DATE, value: formatDate(data.etsDate) },
      ],
    },
    {
      title: T.ADDRESS_INFO,
      icon: "pi-map-marker",
      fields: [
        { label: T.ADDRESS_LINE1, value: data.addressLine1, icon: "pi-home" },
        { label: T.ADDRESS_LINE2, value: data.addressLine2 },
        { label: T.CITY, value: data.city },
        { label: T.STATE, value: data.state },
        { label: T.ZIP_CODE, value: data.zipCode },
        { label: T.COUNTRY, value: data.country },
      ],
    },
  );

  return { sections };
}
